// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MHBn8","largestCol":"styles_largestCol__UC0d7","smallestCol":"styles_smallestCol__ed20L"};